import React, { useState, useEffect } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import {
  CoreTextField,
  CoreButton,
  CoreAutoComplete,
} from 'src/components/core'
import { useDispatch, useSelector } from 'react-redux'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { aICreatorUploadAttachmentSuccess } from 'src/reducers/ai-creator/action'

import styles from './styles'
import {
  ResourceTypeSelector,
  QuestionCountSelector,
  LoadingView,
  PdfView,
} from './components'

const AiQuizPopup = props => {
  const { sectionOptions, classes, onSubmit } = props
  const dispatch = useDispatch()
  const cardCreationProgress = useSelector(
    state => state.course.cardCreationProgress,
  )

  // State
  const [description, setDescription] = useState('')
  const [resourceType, setResourceType] = useState('course')
  const [questionCount, setQuestionCount] = useState(1)
  const [selectedSection, setSelectedSection] = useState({
    name: 'All sections',
    value: 'allsections',
  })
  const [selectedTitle, setSelectedTitle] = useState(null)

  // Reset form when cardCreationProgress changes to false
  useEffect(() => {
    if (!cardCreationProgress) {
      setDescription('')
      setResourceType('course')
      setQuestionCount(1)
      setSelectedSection({
        name: 'All sections',
        value: 'allsections',
      })
      setSelectedTitle(null)
    }
  }, [cardCreationProgress])

  const handleResourceTypeChange = newResourceType => {
    dispatch(aICreatorUploadAttachmentSuccess(null, null))
    setResourceType(newResourceType)
    setSelectedTitle(null)
    setDescription('')
    if (newResourceType === 'ai') {
      const inputElement = document.getElementById('description-input')
      if (inputElement) {
        inputElement.focus()
      }
    }
  }

  const handleSectionChange = (event, value) => {
    setSelectedSection(value)
  }

  const handlePdfChange = data => {
    setSelectedTitle(data.selectedContent)
  }

  const handleSubmit = () => {
    if (resourceType === 'ai' && !description.trim()) {
      return
    }

    const quizData = {
      description: resourceType === 'ai' && description.trim(),
      resourceType,
      questionCount,
    }

    if (resourceType === 'course') {
      quizData.section = selectedSection
    } else if (resourceType === 'pdf') {
      if (!selectedTitle) {
        return
      }
      quizData.selectedContent = selectedTitle
      quizData.attachments = selectedTitle
    }

    if (onSubmit) {
      onSubmit(quizData)
    }
  }

  if (cardCreationProgress) {
    return <LoadingView />
  }

  return (
    <div>
      <div className={classes.rootContainer}>
        <ResourceTypeSelector
          resourceType={resourceType}
          onResourceTypeChange={handleResourceTypeChange}
        />
        {resourceType === 'ai' && (
          <div>
            <CoreTextField
              id="description-input"
              autoFocus
              multiline
              value={description}
              onChange={e => setDescription(e.target.value)}
              variant="outlined"
              fullWidth
              label="Description"
              placeholder="Describe the topic or concept you want to generate questions from."
              marginTop={true}
            />
          </div>
        )}
        {resourceType === 'course' && (
          <CoreAutoComplete
            marginTop={true}
            fullWidth
            label="Select section AI will extract questions from"
            defaultValue={{ name: 'All sections', value: 'allsections' }}
            value={selectedSection}
            selectOnFocus
            options={sectionOptions}
            getOptionLabel={option => option.name || ''}
            getOptionSelected={(option, value) => option.value === value.value}
            onChange={handleSectionChange}
            freeSolo={false}
          />
        )}

        {resourceType === 'pdf' && <PdfView onChange={handlePdfChange} />}

        <QuestionCountSelector
          questionCount={questionCount}
          onQuestionCountChange={setQuestionCount}
        />
      </div>

      <div className={classes.buttonContainer}>
        <CoreButton
          variant="text"
          color="secondary"
          onClick={() => dispatch(messageBoxHideAction('message-box-1'))}
        >
          Back
        </CoreButton>
        <CoreButton
          variant="contained"
          color="primary"
          className={classes.addButton}
          onClick={handleSubmit}
          disabled={
            (resourceType === 'ai' && !description.trim()) ||
            (resourceType === 'pdf' && !selectedTitle) ||
            (resourceType === 'course' && !selectedSection)
          }
        >
          Generate Questions
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(AiQuizPopup)
